import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DocumentService } from 'src/app/Services/Documents/document.service';
import { Observable } from 'rxjs';
import { IDocument } from 'src/app/models/IDocument';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-manage-catgories',
  templateUrl: './manage-catgories.component.html',
  styleUrls: ['./manage-catgories.component.css']
})
export class ManageCatgoriesComponent implements OnInit {

  ManageCategoryForm: FormGroup;
  categoryInfo: IDocument;
  public docCatList: IDocument[] = [];
  public subCatList: IDocument[] = [];
  private selectedLink: string;
  message: string;
  locationId:number=0;
  patId:number=0;

  constructor(private fb: FormBuilder,
    private docService: DocumentService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ManageCatgoriesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 

      if(sessionStorage.getItem("LocationId") != null || Number(sessionStorage.getItem("LocationId")) != 0){
        this.locationId = parseInt(sessionStorage.getItem("LocationId"));
      }
      if(sessionStorage.getItem("patientId") != null || Number(sessionStorage.getItem("patientId")) != 0){
        this.patId = parseInt(sessionStorage.getItem("patientId"));
      }
    
    }

  ngOnInit() {
    this.ManageCategoryForm = this.fb.group({
      docCategoryId: [''],
      documentCategory: [''],
      subCategoryId: [''],
      subCategoryName: [''],
      allLocations: ['']
      //facilityId: ['']
    });
    this.GetIDocInfo();
    this.getAllDocCategoryList();
    this.GetFacilityDetails();
    this.setradio('Category');

    //this.ManageCategoryForm.patchValue({ docCategoryId: '', subCategoryName: '', documentCategory: '' });
  }
  checkBoxAllLocations(event) {
  }
  GetFacilityDetails() {
    this.ManageCategoryForm.patchValue({
      //facilityId: this.data.value.facilityId,
    });
  }

  GetIDocInfo() {
    this.categoryInfo = {
      documentId: null,
      documentName: '',
      documentdate: '',
      subCategoryId: null,
      subCategoryName: '',
      docCategoryId: null,
      documentCategory: '',
      patientId: null,
      patFullName: '',
      patDOB: null,
      patGender: '',
      patAge: null,
      extension: '',
      encounterId: '',
      facilityId: null,
      createdBy: '',
      locationId:null,
      fluoroscopeId: null,
      count: null,
      reportDocumentId: null
    }
  }

  mapFormValuesToDocumetModel() {
   // alert(encodeURIComponent(sessionStorage.getItem("LocationId")).toString())
    this.categoryInfo.documentCategory = this.ManageCategoryForm.value.documentCategory;
    this.categoryInfo.facilityId = Number(sessionStorage.getItem("FacilityId"));
    //Number(sessionStorage.getItem("FacilityId"));
    this.categoryInfo.docCategoryId = this.ManageCategoryForm.value.docCategoryId;
    this.categoryInfo.subCategoryId = this.ManageCategoryForm.value.subCategoryId;
    this.categoryInfo.subCategoryName = this.ManageCategoryForm.value.subCategoryName;
    this.categoryInfo.locationId = this.locationId;
    this.categoryInfo.extension = 'true';
    // if(this.ManageCategoryForm.value.allLocations == true){
    //   this.categoryInfo.extension = 'true';
    // }else{
    //   this.categoryInfo.extension = '';
    // }
  }

  getAllDocCategoryList() {
   // if(this.patId !==0 && this.patId !== undefined)
    //{
      this.patId=0; //patientid is not using in procedures so commented
      this.docService.getAllDocCategory(this.patId,Number(sessionStorage.getItem("FacilityId"))).subscribe(data => {
        this.docCatList = data;
        this.getAllSubCategoryList();
      });
    //}else{
    //  this.toastr.warning("Please select Patient Id");
    //}    
  }

  getAllSubCategoryList() {
    this.docService.getAllSubCategory().subscribe(data => {
      this.subCatList = data;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  setradio(e: string): void {
    this.selectedLink = e;
    this.message = "";
    this.ManageCategoryForm.patchValue({ docCategoryId: '', subCategoryName: '', documentCategory: '' });
  }

  isSelected(name: string): boolean {
    if (!this.selectedLink) { // if no radio button is selected, always return false so every nothing is shown  
      return false;
    }
    return (this.selectedLink === name); // if current radio button is selected, return true, else return false  
  }

  onCatSubmit() {
    this.mapFormValuesToDocumetModel();
    if (this.ManageCategoryForm.value.documentCategory === "") {
      this.message = "Please Enter Category"
    } else {
      var dupCat = this.docCatList.filter(x => x.documentCategory === this.ManageCategoryForm.value.documentCategory);
      if (dupCat.length > 0) {
        this.toastr.warning('Category Name Already Exist');
      } else {
        this.dialogRef.close(this.categoryInfo);
        this.message = "";
      }
    }
  }

  onSubCatSubmit() {

    this.mapFormValuesToDocumetModel();
    if (this.ManageCategoryForm.value.subCategoryName === "" || this.ManageCategoryForm.value.docCategoryId === "" || this.ManageCategoryForm.value.docCategoryId === undefined) {
      this.message = "Enter Category & Document Type"
    } else {
      var subCat = this.subCatList.filter(x => x.docCategoryId === this.ManageCategoryForm.value.docCategoryId);
      var dupSub = subCat.filter(x => x.subCategoryName === this.ManageCategoryForm.value.subCategoryName);
      if (dupSub.length > 0) {
        this.toastr.warning('Document Type Name Already Exist');
      } else {
        this.dialogRef.close(this.categoryInfo);
        this.message = "";
      }
    }
  }

}
